export default {
  ROTATION: "rotation",
  NEW_ON_GONOODLE: "new on gonoodle",
  TOPICS: "topics",
  FEATURED_ACTIVITIES: "featured activities",
  MEET_THE_CHAMPS: "meet the champs",
  ALL_VIDEOS: "all videos",
  ALL_ACTIVITIES: "all activities",
  YOU_MIGHT_LIKE: "you might like",
  PAIRED_VIDEO: "paired video",
  PAIRED_PRINTABLE: "paired printable",
  DOWNLOAD_BUTTON: "download button",
  FEATURED_VIDEOS: "featured videos",
  SHARE: "share",
  SEARCH: "search",
  FEATURED_BLOG_POSTS: "featured blog posts",
  ALL_BLOG_POSTS: "all blog posts",
  DIRECT: "direct",
};
